export default {
  services: {
    portal: {
      available: true,
      superuser: true,
    },
    maps: {
      available: false,
      superuser: true,
    },
    geocontrib: {
      available: false,
      superuser: true,
    },
    stats: {
      available: false,
      superuser: false,
    },
    geoserver: {
      available: false,
      superuser: true,
    },
    geonetwork: {
      available: false,
      superuser: true,
    },
  },
  components: {
    QualityLabel: 'dataset-detail-top-anchor',
  },
  itemsPerPage: {
    datasets: 20,
    jurisdictions: 20
  },
  forms: {
    user: {
      hiddenFields: [],
      requiredFields: [
        'last_name',
        'first_name',
        'email'
      ]
    },
    organisation: {
      hiddenFields: [],
      requiredFields: [
        'display_name',
        'organisation_type'
      ]
    },
    group: {
      hiddenFields: [],
      requiredFields: [
        'name'
      ]
    },
    sphere: {
      hiddenFields: [],
      requiredFields: [
        'name'
      ]
    },
    contact: {
      hiddenFields: [],
      requiredFields: [
        'name',
        'email'
      ]
    },
    dataset: {
      hiddenFields: [],
      requiredFields: [
        'display_name',
        'description',
        'keywords',
        'topics',
        'kinds',
        'usergroup',
        'publication_date',
        'last_update_date',
        'update_frequency',
        'record_type',
      ],
      extraFields: [
        // For e.g.
        // {
        //   title: {
        //     en: 'Datavisualization',
        //     fr: 'Datavisualization',
        //   },
        //   icon: 'dataviz',
        //   fields: [
        //     {
        //       key: 'dataviz_href',
        //       label: {
        //         en: 'URL',
        //         fr: 'URL',
        //       },
        //       help: {
        //         en: 'Enter the URL of the data to reference',
        //         fr: 'Entrer l\'url de la donnée à référencer'
        //       }
        //     },
        //   ]
        // },
      ],
    },
    resource: {
      datastore: {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      'file-upload': {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'column_x',
          'column_y',
          'crs'
        ]
      },
      ftp: {
        superuserOnly: true,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      'file-download': {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      href: {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      geoserver: {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      }
    },
    indexer: {
      hiddenFields: [],
      requiredFields: [
        'name',
        'url',
        'command',
        'scheduler',
      ]
    }
  },
  resourceTypes: [
    'file-upload',
    'file-download',
    'ftp',
    'href',
    'datastore',
    'geoserver'
  ],
  annexTypes: [
    'file-upload',
    'ftp',
    'href',
  ],
  wms: {
    staticBaseUrl:'/maps'
  }
};
